import React from "react";

/* Import component props */
import PropsGroup from "./PropsGroup.jsx";
//import SelectShapeGroup from "../SelectShapeGroup.jsx";
import SelectColorGroup from "../SelectColorGroup.jsx";
//import SelectViewGroup from "../SelectViewGroup.jsx";
import DemoAppStyle from "../styles/style.module.css";

import Typography from "../../core/Typography";
import { SidebarContainer } from "../components/SidebarContainer";

/**Import demo component body*/
import { DEMO } from "./DemoComponent.jsx";
/**Import usage & API  of component*/
import { API } from "./api.jsx";

/**SETTINGS OF THIS DEMO*/
/*Set component data (variables)*/
const Props = {
  name: "Slider",
  desc:
    "A slider is a numeric input for choosing numbers between lower and upper bounds. It also has a labeled axis that supports custom formatting.",
  /**default value*/
  type: "def",
  view: "filled",
  color: "primary"
};
/**Available variants of TYPES & VIEWS (variables)*/
//const shapes = [["Default", "def"]];
//const views = [["Filled", "filled"]];
/**END OF SETTINGS*/

/**Demo template*/
const Content = props => {
  /*Set states of props*/
  const [value, setValue] = React.useState(60);
  const [vertical, setVertical] = React.useState(false);

  //const [shape, setShape] = React.useState(Props.type);
  //const [view, setView] = React.useState(Props.view);
  const [color, setColor] = React.useState(Props.color);

  React.useEffect(() => {
    document.title = `React Design System: component ${Props.name}`;
    document.getElementsByTagName("META")["description"].content = `Demo ${
      Props.name
    } component for React Setproduct Design System with possible props. ${
      Props.desc
    }`;
  });

  return (
    <div>
      <div className={DemoAppStyle["content-component"]}>
        {/*COMPONENT*/}
        {/*NAME*/}
        <Typography type="h4" className="demo-name">
          {Props.name}
        </Typography>
        {/*Description */}
        <Typography type="h6" colorStep={60} className="demo-desc">
          {Props.desc}
        </Typography>
        {/*Content*/}
        <div className="demo-content-component" style={{ padding: "1.5rem" }}>
          <DEMO
            color={color}
            value={value}
            setValue={setValue}
            vertical={vertical}
          />
        </div>
        <div className="BodyBig demo-api">
          <API
            name={Props.name}
            color={color}
            value={value}
            setValue={setValue}
            vertical={vertical}
          />
        </div>
      </div>
      {/* Props*/}
      <SidebarContainer>
        <div className={DemoAppStyle["right_sidebar"]}>
          {/**Set this Props component */}
          <div className={DemoAppStyle["demo-props"]}>
            <PropsGroup
              vertical={vertical}
              setVertical={setVertical}
              margin="4px"
            />
            {/*}    <SelectShapeGroup
              shape={shape}
              setShape={setShape}
              shapes={shapes}
            />
  <SelectViewGroup view={view} setView={setView} views={views} />*/}
            <SelectColorGroup color={color} setColor={setColor} />
          </div>
        </div>
      </SidebarContainer>
      {/***** */}
    </div>
  );
};

export default Content;
